module.exports = __webpack_public_path__ + "img/bh_1.732c3b6a.jpg";